<div class="panel-card col-md-auto" data-test-selector="panel-card">
  <h5 class="panel-card-title border-primary" data-test-selector="panel-card-heading-text">
    {{ headingText }}
  </h5>
  <div class="panel-card-body text-end">
    <ng-content></ng-content>
  </div>
</div>
